import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './action';
import getters from './getters';
import { constantRouterMap } from '@/router/router';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const state = {
  token: '',
  userInfo: {}, // 用户信息
  userRoleInfo: {},
  routers: constantRouterMap,
  addRouters: [],
  areasTip: false, //物业区域选择
  mechanism: false, //建设单位机构选择
  propertyComp: false, //物业区域选择
  ownerComp: false, //业主选择组件
  homeReportname: '', //报表名字
  committeeSelect: false, //业主委员会选择
  subdistrictOffice: false, //街道办选择
  neighborhoodCommittee: false, //居委会选择
  committeeMember: false, //业委会成员选择
  employeeComp: false, //从业人员、项目负责人组件
  committeeComp: false, //业委会选择
  detailTip: false, //投票详情选择
  paperTip: false, //纸质投票登记
  tabsRouter: [
    {
      path: '/index',
      name: '首页',
    },
  ],
  currentPage: 0, //pdf文件页码
  pageCount: 0, //pdf文件总页码数
  InformationManagerData: {},
  code: '',
  reFreshTime: 0,
  fileList: [],
  enterForm:{},
  basicInfoId:'',
  basicInfo:{},
  end:'',
  trendAreaList: [],
  sourceAreaList: [],
  accessAreaList: [],
  trendCode: '',
  sourceCode: '',
  accessCode: ''
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState({
    paths:['tabsRouter'], // 只持久化特定的模块
    storage: window.sessionStorage // 使用 sessionStorage
  })]
});
